module.exports = __webpack_public_path__ + "img/gpupr@2x.2469b467.png";